import type { FC } from "react";
import React from "react";

import { MediaList } from "@react/domains/media";
import { useInfiniteQuery } from "@react/foundation/query";

import { useQueries } from "../../../../../shared/hooks/useQueries.ts";

export const MediaGallery: FC = () => {
  const { getMediaPreviewsQueryOptions } = useQueries();
  const mediaPreviewsQueryOptions = getMediaPreviewsQueryOptions({
    limit: 24,
    order: "desc",
  });

  const previews = useInfiniteQuery(mediaPreviewsQueryOptions.infinite);

  return (
    <MediaList
      error={previews.error}
      isFetchingNextPage={previews.isFetchingNextPage}
      isPending={previews.isPending}
      items={previews.items}
      onEndReached={previews.loadNextPage}
    />
  );
};
